SA.CrosstabVerticalPercentTooltip = class {
    static create({state, target}) {
        var formatPercent = (state, id) => SA.CrosstabBodyCell.formatPercent(state.data[`% of ${id}`]),
            html, tooltip;

        if (state.ids.top === 'total') {
            html = [
                '<div class="sa-crosstab-tooltip-title">Total Vertical Percent</div>',
                `<div>Of all of the people who took this survey${state.location !== 'usa:840' ? ` in ${Ext.String.htmlEncode(SA.data.LocationsCache.get(state.location).name)}` : ''}</div>`,
                `<div><span class="sa-crosstab-tooltip-percent">${formatPercent(state, state.ids.top)}</span> are in this group:</div>`,
                `<div>${Ext.String.htmlEncode(SA.data.AttributesCache.get(state.ids.left).name)}</div>`
            ];
        }
        else {
            html = [
                '<div class="sa-crosstab-tooltip-title">Vertical Percent</div>',
                '<div class="sa-crosstab-tooltip-definition">The percent of respondents who first meet the column criterion and then meet the row criterion.</div>',
                '<div>Of the people in this group:</div>',
                `<div>${Ext.String.htmlEncode(SA.data.AttributesCache.get(state.ids.top).name)}</div>`,
                `<div><span class="sa-crosstab-tooltip-percent">${formatPercent(state, state.ids.top)}</span> of them are also in this group:</div>`,
                `<div>${Ext.String.htmlEncode(SA.data.AttributesCache.get(state.ids.left).name)}</div>`
            ];
        }

        tooltip = new SA.Tooltip({content: html.join(''), target});

        tooltip.el.classList.add('sa-crosstab-tooltip');

        return tooltip;
    }
};